export enum EFGChatMessageType {
  CMT_PlayerMessage,
  CMT_SystemMessage,
  CMT_AdaMessage,
}
